import {
  type ContainerProperties,
  Container as ContainerUIKit,
} from "@react-three/uikit";

export interface ContainerProps extends ContainerProperties {
  children?: React.ReactNode;
}

export function Container({ children, ...props }: ContainerProps) {
  return (
    <ContainerUIKit display="flex" {...props}>
      {children}
    </ContainerUIKit>
  );
}
